var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.5C9.21522 2.5 9.40628 2.63772 9.47434 2.84189L15 19.4189L17.5257 11.8419C17.5937 11.6377 17.7848 11.5 18 11.5H22C22.2761 11.5 22.5 11.7239 22.5 12C22.5 12.2761 22.2761 12.5 22 12.5H18.3604L15.4743 21.1581C15.4063 21.3623 15.2152 21.5 15 21.5C14.7848 21.5 14.5937 21.3623 14.5257 21.1581L9 4.58114L6.47434 12.1581C6.40628 12.3623 6.21522 12.5 6 12.5H2C1.72386 12.5 1.5 12.2761 1.5 12C1.5 11.7239 1.72386 11.5 2 11.5H5.63962L8.52566 2.84189C8.59372 2.63772 8.78478 2.5 9 2.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/activity.cc52237f835e2b349b8924ab9ccb8064.svg";